import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import { Provider as AlertProvider, AlertProviderProps } from 'react-alert';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { FlagProvider } from '@unleash/proxy-client-react';
import { store } from './app/store';
import ErrorBoundaryProvider from './components/ErrorBoundary';
import AlertTemplate from './components/common/AlertTemplate';
import AuthProvider from './contexts/AuthContext/AuthProvider';
import { TaskLoadingMetricsProvider } from './hooks/taskLoadingMetrics/TaskLoadingMetricsContext';
import './index.css';
import router from './pages/router';
import './scripts/HackTimer';
import theme from './utils/theme';
import unleashConfig from './utils/unleash';
import { setupOTELSDK } from './otel';

const options: AlertProviderProps = {
  template: AlertTemplate,
  position: 'top center',
  offset: '130px',
  transition: 'scale',
};

setupOTELSDK();

(window as any).__HITL_BUILD_NUMBER__ = process.env.REACT_APP_HITL_BUILD_NUMBER;

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <ErrorBoundaryProvider>
          <AlertProvider {...options}>
            <TaskLoadingMetricsProvider>
              <AuthProvider>
                <FlagProvider config={unleashConfig}>
                  <RouterProvider router={router} />
                </FlagProvider>
              </AuthProvider>
            </TaskLoadingMetricsProvider>
          </AlertProvider>
        </ErrorBoundaryProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

if (window.hasOwnProperty('Cypress')) {
  (window as any).store = store;
}
